module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "aut"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("By the same author")])]), _vm._v(" "), _c('p', {
    staticClass: "aut1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Active Goodness: The True Story of How Trevor Chadwick, Doreen Warriner & Nicholas Winton Rescued Thousands from the Nazis")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1c40e92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Author.vue
// module id = 69
// module chunks = 0